/**
 * TOPO (Topografie) Module Seeds - DDD Canonical Location
 *
 * All 23 families physically in DDD location.
 * Batch 1: NL-PROV, NL-WATER, NL-LANDSCHAP, NL-BUURLANDEN, NL-EILANDEN, KLIMAAT, EU-FYSISCH
 * Batch 2: NL-STEDEN, NL-STEDEN-REGIO, EU-LAND, EU-HOOFDST, EU-BUURLANDEN, EU-ZEEEN, EU-RIVIEREN, EU-GEBERGTE, EU-KLIMAAT
 * Batch 3: WERELD-CONT, WERELD-HOOFDST, WERELD-OCEANEN, WERELD-LANDEN, WERELD-RIVIER, WERELD-GEBERGTE, WERELD-KLIMAAT
 *
 * Phase H-7 original, DDD move 13 maart 2026.
 * Batch 1 physical migration 15 maart 2026.
 * Batch 2 physical migration 15 maart 2026.
 * Batch 3 physical migration 15 maart 2026.
 * STEDEN split (STEDEN + STEDEN-REGIO) 15 maart 2026.
 */

// === Batch 1: NL + KLIMAAT + EU-FYSISCH ===
import topoNlProv from './TOPO-NL-PROV.json';
import topoNlWater from './TOPO-NL-WATER.json';
import topoNlLandschap from './TOPO-NL-LANDSCHAP.json';
import topoNlBuurlanden from './TOPO-NL-BUURLANDEN.json';
import topoNlEilanden from './TOPO-NL-EILANDEN.json';
import topoNlRivieren from './TOPO-NL-RIVIEREN.json';
import topoKlimaat from './TOPO-KLIMAAT.json';
import topoEuFysisch from './TOPO-EU-FYSISCH.json';

// === Batch 2: NL-STEDEN + EU ===
import topoEuLand from './TOPO-EU-LAND.json';
import topoEuHoofdst from './TOPO-EU-HOOFDST.json';
import topoNlSteden from './TOPO-NL-STEDEN.json';
import topoNlStedenRegio from './TOPO-NL-STEDEN-REGIO.json';
import topoEuZeeen from './TOPO-EU-ZEEEN.json';
import topoEuRivieren from './TOPO-EU-RIVIEREN.json';
import topoEuBuurlanden from './TOPO-EU-BUURLANDEN.json';
import topoEuGebergte from './TOPO-EU-GEBERGTE.json';
import topoEuKlimaat from './TOPO-EU-KLIMAAT.json';

// === Batch 3: WERELD ===
import topoWereldCont from './TOPO-WERELD-CONT.json';
import topoWereldHoofdst from './TOPO-WERELD-HOOFDST.json';
import topoWereldOceanen from './TOPO-WERELD-OCEANEN.json';
import topoWereldRivier from './TOPO-WERELD-RIVIER.json';
import topoWereldGebergte from './TOPO-WERELD-GEBERGTE.json';
import topoWereldLanden from './TOPO-WERELD-LANDEN.json';
import topoWereldKlimaat from './TOPO-WERELD-KLIMAAT.json';
const TOPO_FAMILY_SEEDS = [{
  file: 'src/content/seeds/TOPO/TOPO-EU-FYSISCH.json',
  data: topoEuFysisch
}, {
  file: 'src/content/seeds/TOPO/TOPO-EU-LAND.json',
  data: topoEuLand
}, {
  file: 'src/content/seeds/TOPO/TOPO-EU-HOOFDST.json',
  data: topoEuHoofdst
}, {
  file: 'src/content/seeds/TOPO/TOPO-EU-ZEEEN.json',
  data: topoEuZeeen
}, {
  file: 'src/content/seeds/TOPO/TOPO-EU-RIVIEREN.json',
  data: topoEuRivieren
}, {
  file: 'src/content/seeds/TOPO/TOPO-KLIMAAT.json',
  data: topoKlimaat
}, {
  file: 'src/content/seeds/TOPO/TOPO-NL-PROV.json',
  data: topoNlProv
}, {
  file: 'src/content/seeds/TOPO/TOPO-NL-WATER.json',
  data: topoNlWater
}, {
  file: 'src/content/seeds/TOPO/TOPO-NL-RIVIEREN.json',
  data: topoNlRivieren
}, {
  file: 'src/content/seeds/TOPO/TOPO-NL-STEDEN.json',
  data: topoNlSteden
}, {
  file: 'src/content/seeds/TOPO/TOPO-NL-STEDEN-REGIO.json',
  data: topoNlStedenRegio
}, {
  file: 'src/content/seeds/TOPO/TOPO-NL-LANDSCHAP.json',
  data: topoNlLandschap
}, {
  file: 'src/content/seeds/TOPO/TOPO-NL-EILANDEN.json',
  data: topoNlEilanden
}, {
  file: 'src/content/seeds/TOPO/TOPO-NL-BUURLANDEN.json',
  data: topoNlBuurlanden
}, {
  file: 'src/content/seeds/TOPO/TOPO-WERELD-CONT.json',
  data: topoWereldCont
}, {
  file: 'src/content/seeds/TOPO/TOPO-WERELD-HOOFDST.json',
  data: topoWereldHoofdst
}, {
  file: 'src/content/seeds/TOPO/TOPO-WERELD-OCEANEN.json',
  data: topoWereldOceanen
}, {
  file: 'src/content/seeds/TOPO/TOPO-EU-BUURLANDEN.json',
  data: topoEuBuurlanden
}, {
  file: 'src/content/seeds/TOPO/TOPO-WERELD-RIVIER.json',
  data: topoWereldRivier
}, {
  file: 'src/content/seeds/TOPO/TOPO-EU-GEBERGTE.json',
  data: topoEuGebergte
}, {
  file: 'src/content/seeds/TOPO/TOPO-WERELD-GEBERGTE.json',
  data: topoWereldGebergte
}, {
  file: 'src/content/seeds/TOPO/TOPO-EU-KLIMAAT.json',
  data: topoEuKlimaat
}, {
  file: 'src/content/seeds/TOPO/TOPO-WERELD-LANDEN.json',
  data: topoWereldLanden
}, {
  file: 'src/content/seeds/TOPO/TOPO-WERELD-KLIMAAT.json',
  data: topoWereldKlimaat
}] as const;
const allQuestions = TOPO_FAMILY_SEEDS.flatMap(({
  file,
  data
}) => data.questions.map(question => ({
  ...question,
  __sourceFile: file
})));
export default {
  module: 'Topo' as const,
  moduleCode: 'TOPO',
  version: '5.4-steden-split',
  taxonomyVersion: '4.1',
  questions: allQuestions
};